
define('text!templates/widgets/dataGridCells/htmlCell.html',[],function () { return '<span data-bind="html: $data"></span>\n';});

